<template>
  <transition name="fade">
    <modal>
      <div class="bg-greyBackground rounded-md w-96 grid">
        <div class="flex justify-end px-4 py-5 bg-white rounded-t-md">
          <router-link :to="{ name: routeName }">
            <button aria-label="Close Modal" title="Close Modal">
              <img src="../assets/cross.svg" alt="Close Modal" width="20" height="20" />
            </button>
          </router-link>
        </div>

        <div class="grid py-8 justify-center justify-items-center gap-4 text-center">
          <img
            src="../assets/success.svg"
            alt="Success"
            class="w-32 justify-self-center"
            width="119"
            height="115"
          />
          <p class="font-semibold text-xl">
            NACH uploaded successfully
            <br />
            <br />NACH फॉर्म सफलतापूर्वक अपलोड हो गया है
          </p>
          <a :href="referralCallbackUrl" v-if="isReferralFlow">
            <custom-button variant="primary">Thank You/धन्यवाद</custom-button>
          </a>
          <router-link :to="{ name: 'Dashboard' }" v-else-if="registerNow">
            <custom-button variant="primary">Thank You/धन्यवाद</custom-button>
          </router-link>
          <router-link :to="{ name: routeName }" v-else>
            <custom-button variant="primary">Thank You/धन्यवाद</custom-button>
          </router-link>
        </div>
      </div>
    </modal>
  </transition>
</template>
<script>
import { mapGetters } from 'vuex';
import Modal from '../components/Modal.vue';
import CustomButton from '../components/CustomButton.vue';

export default {
  name: 'NACHSuccess',
  components: { Modal, CustomButton },
  data() {
    return {
      routeName: undefined,
      registerNow: localStorage.getItem("registerNow")
    };
  },
  computed: {
    ...mapGetters(['bestApprovedAmount', 'isReferralFlow', 'referralCallbackUrl'])
  },
  mounted() {
    this.init();
  },
  methods: {
  init() {
      this.$trackEvent(this.$mixpanelEvent.NACH_MANDATE_SUCCESS);
      const routeName = this.$route.query.redirectRouteName;
     if (localStorage.getItem("loanOfferRedirect")) {
      this.routeName = 'Loan Agreement';
     } else if (localStorage.getItem("routeName") === 'Application Discrepancy') {
      this.routeName = 'Application Discrepancy';
     } else {
        this.routeName = routeName || 'Dashboard';
     }
    },
  }
};
</script>
